const esOverrides = {
  'company logo': 'logotipo de la empresa',
  'adjust company logo': 'ajustar logotipo',
  'notification preferences': 'preferencias de notificaciones',
  'choose how to receive each type of notification': 'elige cómo recibir cada tipo de notificación',
  'save preferences': 'guardar preferencias',
  'loading preferences': 'cargando preferencias',
  'notification preferences updated': 'preferencias de notificaciones actualizadas',
  'notification preferences could not be loaded': 'no se pudieron cargar las preferencias de notificaciones',
  'notification preferences could not be saved': 'no se pudieron guardar las preferencias de notificaciones',
  'inside Jobifull': 'dentro de Jobifull',
  'push notifications': 'notificaciones push',
  'not available': 'no disponible',
  'application status updates': 'actualizaciones de candidaturas',
  'new job applications': 'nuevas candidaturas a tus ofertas',
  'company recruiter invitations': 'invitaciones a equipos de selección',
  'new jobs matching your alerts': 'nuevas ofertas según tus alertas',
  'recruitment assignments': 'ofertas asignadas al equipo',
  'vacancy expiration updates': 'cierre y renovación de ofertas',
  'the active profile changed; reload before saving': 'el perfil activo cambió; vuelve a cargar antes de guardar',
  'publication period': 'plazo de publicación',
  'the vacancy will be closed automatically on this date': 'la oferta se cerrará automáticamente en esta fecha',
  'expiration date': 'fecha de cierre',
  'save expiration date': 'guardar plazo',
  'renew for 30 days': 'renovar por 30 días',
  'renewals': 'renovaciones',
  'publication period updated': 'plazo guardado',
  'could not load publication period': 'no se pudo cargar el plazo de publicación',
  'could not save publication period': 'no se pudo guardar el plazo de publicación',
  'choose a future expiration date': 'elige una fecha de cierre futura',
  'could not validate the request; please try again': 'no se pudo validar la solicitud. Inténtalo de nuevo',
  'manage jobs': 'gestionar ofertas',
  'job sections': 'secciones de la oferta',
  'job information': 'información de la oferta',
  'save draft': 'guardar borrador',
  dashboard: 'panel',
  'team members': 'miembros',
  'create job': 'crear oferta',
  jobs: 'ofertas de empleo',
  'new job': 'nueva oferta',
  interviews: 'entrevistas',
  'application funnel': 'embudo de candidaturas',
  'my reports': 'mis denuncias',
  subscription: 'suscripción',
  'invite people': 'invitar personas',
  'my curriculum': 'mi currículum',
  'curriculum editor': 'editor de currículum',
  'complete each section to build your professional profile':
    'completa cada sección para construir tu perfil profesional',
  'loading curriculum': 'cargando currículum',
  'edit profile': 'editar perfil',
  'switch account': 'cambiar cuenta',
  adjust: 'ajustar',
  save: 'guardar',
  'if an account exists for this email, a password reset link was sent':
    'si existe una cuenta para este correo electrónico, enviamos un enlace para restablecer la contraseña',
  'post job': 'publicar empleo',
  'remember email': 'recordar correo electrónico',
  'skip to main content': 'saltar al contenido principal',
  'adjust image': 'ajustar imagen',
  'adjust cover photo': 'ajustar foto de portada',
  'adjust profile photo': 'ajustar foto de perfil',
  'choose an image, then adjust the crop before saving':
    'elige una imagen y ajusta el recorte antes de guardar',
  'choose another image': 'elegir otra imagen',
  'choose image': 'elegir imagen',
  'drag the image to change its position':
    'arrastra la imagen para cambiar su posición',
  zoom: 'zoom',
  'horizontal position': 'posición horizontal',
  'vertical position': 'posición vertical',
  'rotate left': 'girar a la izquierda',
  'rotate right': 'girar a la derecha',
  'reset adjustments': 'restablecer ajustes',
  'current image': 'imagen actual',
  'select a jpeg, png or webp image': 'selecciona una imagen JPEG, PNG o WebP',
  'the original image must be a maximum of 10 mb':
    'la imagen original debe tener un máximo de 10 MB',
  'the selected image could not be opened':
    'no se pudo abrir la imagen seleccionada',
  'the saved image will use the crop shown above':
    'la imagen guardada usará el recorte mostrado arriba',
  'processing image': 'procesando imagen',
  'saving image': 'guardando imagen',
  'save image': 'guardar imagen',
  'choose and adjust the image; saving happens in one step':
    'elige y ajusta la imagen; se guardará en un solo paso',
  'update cover photo': 'actualizar foto de portada',
  'update profile photo': 'actualizar foto de perfil',
  'present your professional identity': 'presenta tu identidad profesional',
  'help recruiters recognize you': 'ayuda a los reclutadores a reconocerte',
  'the adjusted image could not be generated':
    'no se pudo generar la imagen ajustada',
  'remove cover photo': 'eliminar foto de portada',
  'remove profile photo': 'eliminar foto de perfil',
  'the image could not be removed': 'no se pudo eliminar la imagen',
  'image removed successfully': 'imagen eliminada correctamente',
  'keep your information, preferences and professional image up to date':
    'mantén actualizadas tu información, preferencias e imagen profesional',
  'manage the contact and language settings used across your account':
    'gestiona los datos de contacto e idioma usados en tu cuenta',
  'introduce yourself clearly to companies and recruiters':
    'preséntate con claridad ante empresas y reclutadores',
  'professional presentation': 'presentación profesional',
  'summarize your experience, strengths and career goals':
    'resume tu experiencia, fortalezas y objetivos profesionales',
  'what to include': 'qué incluir',
  'your current role and years of experience':
    'tu puesto actual y tus años de experiencia',
  'your strongest skills and measurable results':
    'tus competencias más sólidas y resultados medibles',
  'the opportunity and impact you are looking for':
    'la oportunidad y el impacto que buscas',
  'professional summary': 'resumen profesional',
  'write a concise professional summary':
    'escribe un resumen profesional claro y conciso',
  preview: 'vista previa',
  'save summary': 'guardar resumen',
  'professional summary could not be loaded':
    'no se pudo cargar el resumen profesional',
  'professional summary could not be saved':
    'no se pudo guardar el resumen profesional',
  'professional summary updated': 'resumen profesional actualizado',
  'skills and languages': 'competencias e idiomas',
  'manage normalized skills, proficiency levels and languages in your curriculum':
    'gestiona competencias normalizadas, niveles de dominio e idiomas en tu currículum',
  'manage skills and languages': 'gestionar competencias e idiomas',
  'profile visibility': 'visibilidad del perfil',
  'choose who can find and view your professional profile':
    'elige quién puede encontrar y ver tu perfil profesional',
  'public profile': 'perfil público',
  'anyone can find and view your professional profile':
    'cualquier persona puede encontrar y ver tu perfil profesional',
  'companies only': 'solo empresas',
  'only authenticated companies and recruiters can view your profile':
    'solo empresas y reclutadores autenticados pueden ver tu perfil',
  'private profile': 'perfil privado',
  'only you can view your professional profile':
    'solo tú puedes ver tu perfil profesional',
  'save visibility': 'guardar visibilidad',
  'profile visibility could not be loaded':
    'no se pudo cargar la visibilidad del perfil',
  'profile visibility could not be saved':
    'no se pudo guardar la visibilidad del perfil',
  'profile visibility updated': 'visibilidad del perfil actualizada',
  'current location': 'ubicación actual',
  'help companies understand where you are currently based':
    'ayuda a las empresas a entender dónde te encuentras actualmente',
  'your current city': 'tu ciudad actual',
  'save location': 'guardar ubicación',
  'location could not be loaded': 'no se pudo cargar la ubicación',
  'location could not be saved': 'no se pudo guardar la ubicación',
  'select a country for your city': 'selecciona un país para tu ciudad',
  'location updated': 'ubicación actualizada',
  education: 'formación',
  'no education': 'ninguna formación añadida',
  'presentation field must be at least 50 characters':
    'la presentación debe tener al menos 50 caracteres',
  'presentation field must be at most 3000 characters':
    'la presentación debe tener como máximo 3.000 caracteres',
  'this curriculum version is used in an application and is read only; duplicate it to make changes':
    'esta versión del currículum ya se utilizó en una candidatura y se ha conservado; duplícala para realizar cambios',
  'profile photo': 'foto de perfil',
  'not informed': 'no informado',
  'job applications': 'candidaturas',
  'invitation date': 'fecha de invitación',
  'accept invitation': 'aceptar invitación',
  'refuse invitation': 'rechazar invitación',
  'no jobs match your search': 'ninguna oferta coincide con tu búsqueda',
  'loading teams': 'cargando equipos',
  'editing team': 'editando equipo',
  'save team': 'guardar equipo',
  'saving team': 'guardando equipo',
  'create team': 'crear equipo',
  'edit team': 'editar equipo',
  'could not load teams': 'no se pudieron cargar los equipos',
  'could not save team': 'no se pudo guardar el equipo',
  'organizational team': 'equipo organizativo',
  'team assignment does not change individual responsibilities': 'la asignación al equipo no modifica los responsables y colaboradores individuales',
  'no team assigned': 'ningún equipo asignado',
  'create a team in company members first': 'crea un equipo en el área de miembros de la empresa',
  'team assignment saved': 'asignación de equipo guardada',
  'save team assignment': 'guardar asignación de equipo',
  'applied at': 'candidatura enviada el',
  'published at': 'publicado el',
  'checking your application': 'comprobando tu candidatura',
  'could not check your application': 'no se pudo comprobar tu candidatura',
  'application submitted successfully': 'candidatura enviada correctamente',
  'responsible team': 'responsables del proceso',
  'responsible': 'responsable',
  'collaborators': 'colaboradores',
  'no responsible selected': 'ningún responsable seleccionado',
  'save assignments': 'guardar responsables',
  'no active company members': 'no hay miembros activos en la empresa',
  'define who is responsible for this job and who collaborates in the selection': 'define quién es responsable de esta oferta y quién colabora en la selección',
  'job content preview': 'vista previa del contenido de la oferta',
  'this preview does not save or publish the job': 'esta vista muestra el contenido en edición, sin guardar ni publicar la oferta',
  'return to editing': 'volver a la edición',
  'untitled job': 'oferta sin título',
  'job modality': 'modalidad de trabajo',
  'job description': 'descripción de la oferta',
  'working hours': 'jornada laboral',
  'salary': 'salario',
  'contract': 'contrato',
  'company vacancies': 'ofertas de la empresa',
  'application questions': 'preguntas de candidatura',
  'collect comparable answers before the application reaches the recruitment team': 'recopila respuestas comparables antes de que la candidatura llegue al equipo de selección',
  'add question': 'añadir pregunta',
  'remove question': 'eliminar pregunta',
  'no application questions configured': 'no hay preguntas de candidatura configuradas',
  'question': 'pregunta',
  'answer type': 'tipo de respuesta',
  'free text': 'texto libre',
  'yes or no': 'sí o no',
  'single choice': 'selección única',
  'eliminatory': 'eliminatoria',
  'options separated by lines': 'opciones, una por línea',
  'accepted answer': 'respuesta aceptada',
  'write every question before saving': 'escribe todas las preguntas antes de guardar',
  'choose the accepted answer for every eliminatory question': 'elige la respuesta aceptada de cada pregunta eliminatoria',
  'loading application questions': 'cargando preguntas de candidatura',
  'could not load application questions': 'no se pudieron cargar las preguntas de candidatura',
  'could not save application questions': 'no se pudieron guardar las preguntas de candidatura',
  'application questions saved': 'preguntas de candidatura guardadas',
  'answer all required application questions': 'responde a todas las preguntas obligatorias de la candidatura',
  'could not load curricula for this application': 'no se pudieron cargar los currículums para esta candidatura; inténtalo de nuevo',
  'choice questions must include at least one option': 'las preguntas de selección única necesitan al menos una opción',
  'questions are locked because this job already has applications': 'las preguntas están bloqueadas porque esta oferta ya ha recibido candidaturas',
  'you do not have permission to edit application questions': 'no tienes permiso para editar las preguntas de candidatura',
  'search company vacancies': 'buscar ofertas de la empresa',
  'manage drafts, published jobs and applications in one place': 'gestiona borradores, ofertas publicadas y candidaturas en un solo lugar',
};

export default esOverrides;
